import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../AppContext';
import { logout } from '../actions';
import { useAlert } from '../alert/AlertProvider';

export const AuthProvider = ({ children }) => {
  const { state, dispatch } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert } = useAlert();

  useEffect(() => {
    const authMessage = sessionStorage.getItem('auth_redirect_message');
    if (authMessage) {
      try {
        const message = JSON.parse(authMessage);
        showAlert(message);
        sessionStorage.removeItem('auth_redirect_message');
      } catch (error) {
        console.error('Error parsing auth message:', error);
      }
    }
  }, [showAlert]);

  useEffect(() => {
    const validateToken = () => {
      const token = localStorage.getItem('token');
      
      if (!token) {
        return;
      }
      
      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(window.atob(base64));
        
        const expirationTime = payload.exp * 1000;
        const currentTime = Date.now();
        
        if (currentTime >= expirationTime) {
          handleTokenExpiration();
        } else {
          const timeToExpire = expirationTime - currentTime;
          
          if (timeToExpire < 5 * 60 * 1000) {
            showAlert({
              title: 'Session Expiring Soon',
              description: 'Your session will expire in less than 5 minutes.',
              variant: 'warning'
            });
          }
        }
      } catch (error) {
        console.error('Error validating token:', error);
        handleTokenExpiration();
      }
    };
    
    validateToken();
  }, [location.pathname]);
  
  const handleTokenExpiration = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    dispatch(logout());
    
    if (!location.pathname.includes('/login')) {
      showAlert({
        title: 'Session Expired',
        description: 'Your session has expired. Please log in again.',
        variant: 'warning'
      });
      
      navigate('/');
    }
  };

  return children;
};

export default AuthProvider;